/**
 * Component Registry for Cypress at Lewisville Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { SisterProperties } from './components/SisterProperties';
import { PetPolicy } from './components/PetPolicy';
import { Header } from './components/Header';
import { PropertyOverview } from './components/PropertyOverview';
import { FloorplansList } from './components/FloorplansList';
import { PepCallToAction } from './components/PepCallToAction';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  SisterProperties,
  PetPolicy,
  PropertyOverview,
  FloorplansList,
  PepCallToAction,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
